import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { CustomerActions } from './customer.actions';
import { ICustomerState } from './customer.state';

export const initialCustomerState: ICustomerState = {
  model: undefined,
  data: undefined,
  uiState: undefined,
  hasCustomerResponse: false
};

const customerReducerFn = createReducer(
  initialCustomerState,
  on(CustomerActions.reset, (state: ICustomerState, action) => {
    return new StateBuilder<ICustomerState>(initialCustomerState).build();
  }),
  on(CustomerActions.load, (state: ICustomerState, action) => {
    return new StateBuilder<ICustomerState>(state).toLoading().build();
  }),
  on(CustomerActions.loadSuccess, (state: ICustomerState, action) => {
    return new StateBuilder<ICustomerState>(state, { ...action, ...{ hasCustomerResponse: true } }).toLoaded().build();
  })
);

export function customerReducer(state: ICustomerState | undefined, action: Action) {
  return customerReducerFn(state, action);
}
